export function isMessage(candidate) {
    return candidate !== null && typeof candidate === "object" && "type" in candidate;
}
